'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.enableActivityTracking = exports.trackPageViewEvent = exports.trackCustomEvent = undefined;

var _constants = require('./constants');

var _isInitialised = require('./isInitialised');

var _isInitialised2 = _interopRequireDefault(_isInitialised);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var trackCustomEvent = exports.trackCustomEvent = function trackCustomEvent(globalSnowplowName, event, context) {
  if ((0, _isInitialised2.default)(globalSnowplowName)) {
    window[globalSnowplowName](_constants.TRACK_CUSTOM_EVENT, event, context);
  }
};

var trackPageViewEvent = exports.trackPageViewEvent = function trackPageViewEvent(globalSnowplowName, pageName, context) {
  if ((0, _isInitialised2.default)(globalSnowplowName)) {
    window[globalSnowplowName](_constants.TRACK_PAGE_VIEW, pageName, context);
  }
};

var enableActivityTracking = exports.enableActivityTracking = function enableActivityTracking(globalSnowplowName, minimumVisitLength, heartbeatDelay) {
  if ((0, _isInitialised2.default)(globalSnowplowName)) {
    window[globalSnowplowName](_constants.ENABLE_ACTIVITY_TRACKING, minimumVisitLength, heartbeatDelay);
  }
};